<template>
  <div class="staff-msg" v-wechat-title="title">
    <div class="icon_box">
      <div class="icon_bg">
        <van-icon name="success" size="50" color="#fff" />
      </div>
      <div v-if="statusText" class="status_text">{{statusText}}</div>
    </div>
    <div class="checkin-btn">
      <van-button @click="go(route)"  type="info" round block color="linear-gradient(to right, #6BDDB7, #0AA8AF)" >{{ btnText }}</van-button >
    </div>
    <div class="msg-notice">
      <div v-if="notice" class="notice">{{notice}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      btnText: "",
      statusText: "",
      notice:"",
      route:'',
    };
  },
  created(){
    console.log(this.$route.query)
    if(this.$route.query.title)  this.title=this.$route.query.title
    if(this.$route.query.btnText)  this.btnText=this.$route.query.btnText
    if(this.$route.query.statusText)  this.statusText=this.$route.query.statusText
    if(this.$route.query.notice)  this.notice=this.$route.query.notice
    if(this.$route.query.route)  this.route=this.$route.query.route
    
  },
  methods: {
    go(route){
      console.log("从msg回到:",route)
      
      if(route){
        this.$router.replace({name:route})
      }else{
        this.$router.go(-1)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.staff-msg {
  min-height: 100vh;
  background-color: #f9f9f9;
  .icon_box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 10vh;
    margin-bottom: 5vh;

    .icon_bg {
      width: 100px;
      height: 100px;
      background: #0aa8af;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .status_text{
      margin-top: 5vh;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      font-family: PingFangSC-Regular;
      color:#0A0A0A;
    }
  }
  .checkin-btn {
    margin: 0 25px 25px;
    button.van-button.van-button--info.van-button--normal.van-button--block.van-button--round {
      box-shadow:0px 2px 7px 0px rgba(11, 105, 177, 0.29);
    }
  }
  .msg-notice{
    text-align: center;
    margin: 40px 25px;
    font-size: 15px;
    color:#101010;
    .notice{
      text-align: left;
    }
  }
}
</style>